// extracted by mini-css-extract-plugin
export default {"BannerList":"GameBannerList_BannerList__4NYPS"};